import common from "@/services/common";
import NhlAllTeams from "@/services/NhlAllTeam.js";
import axios from "axios";
import _ from "lodash";

const state = () => ({
  Teams: [],
  injuries: [],
  depthChart: [],
  upcomingGames: [],
  operator: "",
  position: "",
  operatorGameType: "",
  cloneTeam: [],
  playersDetail: [],
  loadingStatus: false,
  getTeamStatus: false,
  teamBuildStatus: false,
  topPlaysStatus: false,
  nhlplayerDetailLoader: false,
  AllSlate: [],
  buildTeam: [],
  TeamStack: [],
  savedLineup: [],
  LineupBuild: [],
  // playerInfo: [],
  teamInfo: [],
  playerReset: [],
  exposure: [],
  playerPerTeam: "",
  topPlayers: [],
  setTopPlaysData: [],
  premiumFilterList: [],
  TopStudAndValues: [],
  playerTrends: [],
  fullStats: [],
  scoring: [],
  playerSwap: [],
  status: true,
  goaliesData: [],
  goalieLoader: false,
  lineTeams: [],
  playerStatLoader: false,
  nhl_props: [],
  nhlNews: [],
});

const mutations = {
  SET_EXPOSURE(state, data) {
    if (state.operator == "FanDuel" && state.operatorGameType == "Single") {
      state.exposure.push(data);
    } else {
      state.exposure.push(data);
    }
  },

  REMOVE_EXPOSURE(state) {
    state.exposure = [];
    //console.log('exposure remove nhl', state.exposure);
  },

  SET_TOP_PLAYS(state, data) {
    state.setTopPlaysData = data;
    //console.log('top plays: ', state.setTopPlaysData);
  },

  SHOW_TOP_PLAYS(state, data) {
    state.topPlayers = data;
  },

  SHOW_PREMIUM_FILTER(state, data) {
    state.premiumFilterList = data;
  },

  SET_TEAMS(state, teams) {
    state.Teams = teams;
    // state.newArryTeam.push(...state.Teams);
  },

  SET_INJURIES(state, data) {
    state.injuries = data;
  },

  SET_DEPTHCHART(state, data) {
    state.depthChart = data;
  },

  SET_UPCOMINGGAMES(state, data) {
    state.upcomingGames = data;
  },

  SET_CLONE(state, clone) {
    state.cloneTeam = { ...clone };
    // state.newArrayClone.push(...state.cloneTeam);
  },

  SET_LOADING(state, newLoadingStatus) {
    state.loadingStatus = newLoadingStatus;
  },

  SET_TEAM_LOADER(state, loader) {
    state.getTeamStatus = loader;
  },

  SET_PLAYERDETAIL_LOADER(state, loader) {
    state.nhlplayerDetailLoader = loader;
  },

  SET_BUILD_TEAM_LOADER(state, status) {
    state.teamBuildStatus = status;
  },

  SET_TOP_PLAYS_LOADER(state, status) {
    state.topPlaysStatus = status;
  },

  SET_SLATE(state, slate) {
    state.AllSlate = slate.filter((value) => {
      return value.Operator !== "Yahoo";
    });
  },

  SET_USER_PLAN(state, data) {
    this.state.userModule.userState = data;
  },

  SLATE_STATUS(state, status) {
    state.status = status;
  },

  SET_PLAYER(state, playerDetail) {
    // state.playersDetail = [];
    state.playersDetail = playerDetail;
    //console.log('player nhl', typeof state.playersDetail, state.playersDetail);
  },

  SET_BUILD_TEAM(state, buildTeam) {
    state.buildTeam = buildTeam;
    // //console.log("build team", state.buildTeam);
  },

  SET_PLAYER_SWAP(state, swapData) {
    state.playerSwap = swapData;
  },

  SET_TEAM_STACK(state, teamStack) {
    state.TeamStack = teamStack;
  },

  SET_SAVE_LINEUP(state, lineup) {
    state.savedLineup = lineup;
    // //console.log("@", state.savedLineup);
  },

  SET_LINE_Up_BUILD(state, lineupBuild) {
    state.LineupBuild = lineupBuild;
  },

  SET_TEAM_DETAIL(state, info) {
    state.teamInfo = info;
    // //console.log("teamInfo", typeof state.teamInfo, state.teamInfo);
  },

  SET_RESET_PLAYERS(state, resetData) {
    state.playerReset = resetData;
    // //console.log(state.playerReset);
  },

  SET_PLAYER_PER_TEAM(state, playerPerTeamData) {
    state.playerPerTeam = playerPerTeamData.teamStack.some((element) => {
      return element.minNoOfPlayer > 0;
    });
    //console.log('playerPerTeam', state.playerPerTeam);
  },

  SET_TOP_PLAYERS(state, data) {
    state.TopStudAndValues = data;
    //console.log('top players', state.TopStudAndValues);
  },

  SET_PLAYER_TRENDs(state, data) {
    state.playerTrends = data;
  },

  SET_FULL_STAT(state, data) {
    state.fullStats = data;
  },

  SET_SCORING(state, data) {
    state.scoring = data;
  },

  SET_GOALIES(state, data) {
    state.goaliesData = data;
  },

  GOALIES_LOADER(state, data) {
    state.goalieLoader = data;
  },

  LINE_TEAMS(state, data) {
    state.lineTeams = data;
  },

  PLAYERSTATS_LOADER(state, data) {
    state.playerStatLoader = data;
  },

  SET_NHL_PROPS(state, data) {
    state.nhl_props = data;
  },

  SET_NHL_NEWS(state, data) {
    state.nhlNews = data;
  },
};

const actions = {
  async getSlate({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    try {
      const res = await NhlAllTeams.getAllSlate(
        payload || localStorage.getItem("user")
      );
      commit("SET_SLATE", res.data.data);
      commit("SLATE_STATUS", res.data.success);

      if (res.data.success) {
        const notification_1 = {
          type: "success",
          message: "Success",
        };
        dispatch("notification/add", notification_1, { root: true });
        commit("SET_USER_PLAN", res.data.userData);
      }
      commit("SET_LOADING", false);
    } catch (err) {
      const notification = {
        type: "error",
        message: "There was an error with Get All Slates: " + err.message,
      };
      dispatch("notification/add", notification, { root: true });
    }
  },

  async getPlayer({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    try {
      const res = await NhlAllTeams.getPlayersDetails(payload);
      commit("SET_PLAYER", res.data.data);
      commit("SET_LOADING", false);
    } catch (err) {
      console.error("There was an error with Get Players" + err.message);
    }
  },

  async getTeamDetails({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    await NhlAllTeams.teamDetails(payload)
      .then((res) => {
        //  ;
        commit("SET_TEAM_DETAIL", res.data);
        commit("SET_LOADING", false);
      })
      .catch((err) => {
        const notification = {
          type: "error",
          message: "There was an error with Get Team Details: " + err.message,
        };
        dispatch("notification/add", notification, { root: true });
      });
  },

  async getBuildTeam({ commit, dispatch }, params) {
    commit("SET_BUILD_TEAM_LOADER", true);
    await NhlAllTeams.getTeamBuild(params)
      .then((res) => {
        commit("SET_BUILD_TEAM", res.data);
        commit("SET_BUILD_TEAM_LOADER", false);
        if (res.data.status == 1 || res.data.allTeams.length == 0) {
          const notification = {
            type: "error",
            message: "No Lineup has been created!!",
          };
          return dispatch("notification/add", notification, { root: true });
        } else {
          const notification_1 = {
            type: "success",
            message: "Team has been Created.",
          };
          return dispatch("notification/add", notification_1, { root: true });
        }
      })
      .catch((err) => {
        console.error(err);
        const notification = {
          type: "error",
          message: "There was an error with Get Build Teams",
        };
        dispatch("notification/add", notification, { root: true });
      });
  },

  async FetchSwapPlayer({ commit }, payload) {
    try {
      const res = await NhlAllTeams.getPlayerSwap(payload);
      commit("SET_PLAYER_SWAP", res.data);
    } catch (err) {
      console.error("There was an error with Get Players swap" + err.message);
    }
  },

  async resetPlayers({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    await NhlAllTeams.resetPlayers(payload)
      .then((res) => {
        commit("SET_RESET_PLAYERS", res.data);
        commit("REMOVE_EXPOSURE");
        commit("SET_LOADING", false);
        const notification = {
          type: "success",
          message: "Player has been reset.",
        };
        dispatch("notification/add", notification, { root: true });
      })
      .catch((err) => {
        const notification = {
          type: "error",
          message: "There was an error with Unlock Player: " + err.message,
        };
        dispatch("notification/add", notification, { root: true });
      });
  },

  getSaveLineup({ commit, dispatch }, buildTeam) {
    commit("SET_BUILD_TEAM_LOADER", true);
    NhlAllTeams.savedLineup(buildTeam)
      .then((res) => {
        commit("SET_SAVE_LINEUP", res.data.doc);
        commit("SET_BUILD_TEAM_LOADER", false);
        if (!res.data.success) {
          const notification = {
            type: "error",
            message: "Error please try again!!",
          };
          return dispatch("notification/add", notification, { root: true });
        } else {
          const notification_1 = {
            type: "success",
            message: "Build saved successfully.",
          };
          return dispatch("notification/add", notification_1, { root: true });
        }
      })
      .catch((err) => {
        const notification_1 = {
          type: "error",
          message: "There was an error with Get save Lineup.: " + err.message,
        };
        dispatch("notification/add", notification_1, { root: true });
      });
  },

  getTeamStack({ commit, dispatch }, slateId) {
    commit("SET_LOADING", true);
    NhlAllTeams.getTeamStack(slateId)
      .then((res) => {
        commit("SET_TEAM_STACK", res.data);
        commit("SET_LOADING", false);
      })
      .catch((err) => {
        const notification = {
          type: "error",
          message: "There was an error with Get Team Stack: " + err.message,
        };
        dispatch("notification/add", notification, { root: true });
      });
  },

  getPlayerPerTeam({ commit }, TeamDetails) {
    commit("SET_LOADING", true);
    NhlAllTeams.playerPerTeam(TeamDetails)
      .then((response) => {
        commit("SET_PLAYER_PER_TEAM", response.data.result);
        commit("SET_LOADING", false);
      })
      .catch((err) => {
        const notification = {
          type: "error",
          message: "There was an error with Get Player per team." + err.message,
        };
        dispatch("notification/add", notification, { root: true });
      });
  },

  async SetExposure({ commit, dispatch }, values) {
    await axios
      .post("https://api.fantasylineups.com/user/setExposure", values)
      .then((res) => {
        if (res.data.success == false) {
          commit("SET_EXPOSURE", res.data.doc);
          const notification = {
            type: "error",
            message: res.data.message,
          };
          dispatch("notification/add", notification, { root: true });
        } else {
          commit("SET_EXPOSURE", res.data.doc);
        }
      })
      .catch((err) => {
        const notification = {
          type: "error",
          message: "There was an error with SetExposure: " + err.message,
        };
        dispatch("notification/add", notification, { root: true });
      });
  },

  async unlockPlayers({ commit, dispatch }, payload) {
    await NhlAllTeams.unlockPlayer(payload)
      .then((res) => {})
      .catch((err) => {
        const notification = {
          type: "error",
          message: "There was an error with Unlock Player: " + err.message,
        };
        dispatch("notification/add", notification, { root: true });
      });
  },

  async getTeams({ commit }) {
    commit("SET_TEAM_LOADER", true);
    try {
      const res = await NhlAllTeams.getAllTeams();
      commit("SET_TEAMS", res.data); //* this will responsible to change the actual state not the action method...
      commit("SET_CLONE", res.data);
      commit("SET_TEAM_LOADER", false);
    } catch (err) {
      return console.error("There was an error with getTeams:" + err.message);
    }
  },

  async getInjuries({ commit }, payload) {
    try {
      const res = await NhlAllTeams.getInjuries(payload);
      commit("SET_INJURIES", res.data); //* this will responsible to change the actual state not the action method...
    } catch (err) {
      return console.error(
        "There was an error with getting Injuries:" + err.message
      );
    }
  },

  async getDepth({ commit }, payload) {
    try {
      const res = await NhlAllTeams.getDepthChart(payload);
      commit("SET_DEPTHCHART", res.data); //* this will responsible to change the actual state not the action method...
    } catch (err) {
      return console.error(
        "There was an error with getting Injuries:" + err.message
      );
    }
  },

  async getUpcomingGames({ commit }, payload) {
    try {
      const res = await NhlAllTeams.getUpcomingGames(payload);
      commit("SET_UPCOMINGGAMES", res.data); //* this will responsible to change the actual state not the action method...
    } catch (err) {
      return console.error(
        "There was an error with getting Injuries:" + err.message
      );
    }
  },

  async SetTopPlays({ commit, dispatch }, payload) {
    try {
      const res = await NhlAllTeams.setTopPlays(payload);
      commit("SET_TOP_PLAYS", res.data);
    } catch (err) {
      const notification = {
        type: "error",
        message: "There was an error with setting up top players" + err.message,
      };
      dispatch("notification/add", notification, { root: true });
    }
  },

  async GetTopPlays({ commit, dispatch }, payload) {
    commit("SET_TOP_PLAYS_LOADER", true);
    try {
      const res = await NhlAllTeams.getTopPlays(payload);
      commit("SHOW_TOP_PLAYS", res.data);
      commit("SET_TOP_PLAYS_LOADER", false);
      const notification = {
        type: "success",
        message: "Player updated successfully.",
      };
      dispatch("notification/add", notification, { root: true });
    } catch (err) {
      const notification_1 = {
        type: "error",
        message: "There was an error with showing up top players" + err.message,
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  GetPremiumFilterList({ commit, dispatch }, payload) {
    // commit('SET_TOP_PLAYS_LOADER', true);
    NhlAllTeams.getPremiumFilters(payload)
      .then((res) => {
        commit("SHOW_PREMIUM_FILTER", res.data);
        // commit('SET_TOP_PLAYS_LOADER', false);
      })
      .catch((err) => {
        const notification_1 = {
          type: "error",
          message:
            "There was an error with showing up premium filters" + err.message,
        };
        dispatch("notification/add", notification_1, { root: true });
      });
  },

  async GetTopPlayers({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);
    try {
      const res = await NhlAllTeams.getTopPlayers(payload);
      commit("SET_TOP_PLAYERS", res.data);
      commit("SET_LOADING", false);
    } catch (err) {
      const notification_1 = {
        type: "error",
        message: "There was an error with fetching top players: " + err.message,
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  FetchPlayerTrends({ commit, dispatch }, payload) {
    commit("SET_TEAM_LOADER", true);
    NhlAllTeams.getPlayerTrend(payload)
      .then((res) => {
        commit("SET_PLAYER_TRENDs", res.data.data);
        commit("SET_TEAM_LOADER", false);
        // const notification = {
        //   type: 'success',
        //   message: 'Player trends successfully loaded.',
        // };
        // dispatch('notification/add', notification, { root: true });
      })
      .catch((err) => {
        const notification_1 = {
          type: "error",
          message: "There was an error with player trends: " + err.message,
        };
        dispatch("notification/add", notification_1, { root: true });
      });
  },

  async GetPlayerFullStats({ commit, dispatch }, payload) {
    commit("SET_PLAYERDETAIL_LOADER", true);
    try {
      const res = await NhlAllTeams.getFullStat(payload);
      commit("SET_FULL_STAT", res.data);
      commit("SET_PLAYERDETAIL_LOADER", false);
    } catch (err) {
      const notification_1 = {
        type: "error",
        message: "There was an error with fetching full stats: " + err.message,
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  async GetPlayerScoring({ commit, dispatch }, payload) {
    commit("PLAYERSTATS_LOADER", true);
    try {
      const response = await NhlAllTeams.getPlayerScoring(payload);
      commit("SET_SCORING", response.data);
      commit("PLAYERSTATS_LOADER", false);
    } catch (err) {
      const notification_1 = {
        type: "error",
        message: "There was an error Scoring : " + err.message,
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  updateSavedLineup({ commit, dispatch }, payload) {
    NhlAllTeams.updateLineup(payload)
      .then((response) => {
        const notification = {
          type: "success",
          message: "Lineup update successfully In Nhl.",
        };
        dispatch("notification/add", notification, { root: true });
      })
      .catch((err) => {
        const notification_1 = {
          type: "error",
          message: "There was an error Scoring : " + err.message,
        };
        dispatch("notification/add", notification_1, { root: true });
      });
  },

  SetProjection({ dispatch }, payload) {
    common
      .setProjection(payload)
      .then((res) => {
        if (res.data.success) {
          const notification = {
            type: "success",
            message: "Projection update successfully In Nhl.",
          };
          dispatch("notification/add", notification, { root: true });
        }
      })
      .catch((err) => {
        const notification_1 = {
          type: "error",
          message: "There was an error set Projection : " + err.message,
        };
        dispatch("notification/add", notification_1, { root: true });
      });
  },

  fetchGoalies({ commit }) {
    commit("GOALIES_LOADER", true);
    NhlAllTeams.getGoalies()
      .then((res) => {
        commit("SET_GOALIES", res.data);
        commit("GOALIES_LOADER", false);
      })
      .catch((err) => {
        console.error(err.message);
      });
  },

  fetchLineCombination({ commit }) {
    commit("GOALIES_LOADER", true);
    NhlAllTeams.getLineCombination()
      .then((res) => {
        commit("LINE_TEAMS", res.data);
        commit("GOALIES_LOADER", false);
      })
      .catch((err) => {
        console.error(err.message);
      });
  },

  async getNhlProps({ commit, dispatch }) {
    try {
      const res = await NhlAllTeams.getNhlProps();
      commit("SET_NHL_PROPS", res.data);
      if (res.data.success) {
        const notification = {
          type: "success",
          message: "Data fetched successfully In Nhl.",
        };
        dispatch("notification/add", notification, { root: true });
      }
    } catch (err) {
      const notification_1 = {
        type: "error",
        message: "There was an error with Nhl_props : " + err.message,
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },

  async getNhlNewsData({ commit, dispatch }) {
    commit("SET_LOADING", true);
    try {
      const res = await NhlAllTeams.getNhlNews();
      commit("SET_NHL_NEWS", res.data);
      if (res.data.success) {
        const notification = {
          type: "success",
          message: "News fetched successfully In NHL.",
        };
        dispatch("notification/add", notification, { root: true });
      }
      commit("SET_LOADING", false);
    } catch (err) {
      const notification_1 = {
        type: "error",
        message: "There was an error with NHL daily news : " + err.message,
      };
      dispatch("notification/add", notification_1, { root: true });
    }
  },
};

const getters = {
  getTeamLoader(state) {
    return state.getTeamStatus;
  },

  loadingStatus(state) {
    return state.loadingStatus;
  },

  buildTeamLoader(state) {
    return state.teamBuildStatus;
  },

  topPlayersLoader(state) {
    return state.topPlaysStatus;
  },

  getGoalieLoader(state) {
    return state.goalieLoader;
  },

  getPlayerStatLoader(state) {
    return state.playerStatLoader;
  },

  getSlateID(state) {
    let slateId = state.AllSlate.map((item) => item.SlateID);
    return slateId;
  },

  getPlayerTrends(state) {
    let trendyPlayer = state.playersDetail.filter(
      (value) => parseInt(value.DraftKingsProjection) > 0
    );
    return trendyPlayer;
  },

  getStuds(state) {
    let studs = state.playersDetail.filter(
      (value) => parseInt(value.DraftKingsSalary) > 8000
    );
    return studs;
  },

  getStudForDkClsc(state) {
    let studs = [];

    studs.push(
      state.TopStudAndValues.D_Players,
      state.TopStudAndValues.G_Players,
      state.TopStudAndValues.UTIL_Players,
      state.TopStudAndValues.C_Players,
      state.TopStudAndValues.W_Players
    );

    let newStuds = studs.map((playerPosition) => {
      // //console.log('playerPosition', _.slice(playerPosition, 0, 3));
      let slicedArray = _.slice(playerPosition, 0, 3);
      return slicedArray;
    });

    let finalStuds = [];
    finalStuds.push(
      ...newStuds[0],
      ...newStuds[1],
      ...newStuds[2],
      ...newStuds[3],
      ...newStuds[4]
    );
    finalStuds = _.uniqBy(finalStuds, "Name");
    return finalStuds;
  },

  getStudForDkSngl(state) {
    let studs = [];

    studs.push(
      state.TopStudAndValues.CPT_Players,
      state.TopStudAndValues.UTIL_Players
    );

    let newStuds = studs.map((playerPosition) => {
      let slicedArray = _.slice(playerPosition, 0, 3);
      return slicedArray;
    });

    let finalStuds = [];
    finalStuds.push(...newStuds[0], ...newStuds[1]);
    finalStuds = _.uniqBy(finalStuds, "Name");
    return finalStuds;
  },

  getStudForFdClsc(state) {
    let studs = [];

    studs.push(
      state.TopStudAndValues.D_Players,
      state.TopStudAndValues.G_Players,
      state.TopStudAndValues.UTIL_Players,
      state.TopStudAndValues.C_Players,
      state.TopStudAndValues.W_Players
    );

    let newStuds = studs.map((playerPosition) => {
      let slicedArray = _.slice(playerPosition, 0, 3);
      return slicedArray;
    });

    let finalStuds = [];
    finalStuds.push(
      ...newStuds[0],
      ...newStuds[1],
      ...newStuds[2],
      ...newStuds[3],
      ...newStuds[4]
    );
    finalStuds = _.uniqBy(finalStuds, "Name");
    return finalStuds;
  },

  getStudForFdSngl(state) {
    let studs = [];

    studs.push(state.TopStudAndValues.MVP_Players);

    let newStuds = studs.map((playerPosition) => {
      let slicedArray = _.slice(playerPosition, 0, 3);
      return slicedArray;
    });

    let finalStuds = [];
    finalStuds.push(...newStuds[0]);
    finalStuds = _.uniqBy(finalStuds, "Name");
    return finalStuds;
  },

  NewgetStuds(state, getters) {
    let operator = localStorage.getItem("gameOperator");
    let gameType = localStorage.getItem("gameType");
    if (state.TopStudAndValues) {
      if (operator == "DraftKings" && gameType == "Classic") {
        //console.log('$', operator, gameType);
        return getters.getStudForDkClsc;
      } else if (operator == "DraftKings" && gameType == "Single") {
        //console.log('$', operator, gameType);
        return getters.getStudForDkSngl;
      } else if (operator == "FanDuel" && gameType == "Classic") {
        //console.log('$', operator, gameType);
        return getters.getStudForFdClsc;
      } else if (operator == "FanDuel" && gameType == "Single") {
        //console.log('$', operator, gameType);
        return getters.getStudForFdSngl;
      }
    } else return;
  },

  getValue(state) {
    let values = state.playersDetail.filter(
      (player) =>
        !player.DraftKingsPosition.includes("DST") &&
        parseInt(player.FPPDdraftking) < 550
    );
    return values;
  },

  // ? filter by position...
  getFilterBySingle: (state) => (val) => {
    let filterPlayer = [];
    if (val == "CPT") {
      val = "CPT";
      state.position = "1";
    } else if (val == "FLEX") {
      val = "FLEX";
      state.position = "2";
    } else if (val == "Lck/Exl") {
      // debugger;
      filterPlayer = state.playersDetail.filter(
        (_players) =>
          _players.type.includes("lock") || _players.type.includes("exclude")
      );
      return filterPlayer;
    }

    filterPlayer = state.playersDetail.filter((item) => {
      // //console.log("item", item.OperatorRosterSlots);
      return item.OperatorRosterSlots == val;
    });
    //console.log(filterPlayer);
    return filterPlayer;
  },

  getFilterByPositionInFanduel: (state) => (val) => {
    let filterPlayers = [];
    if (val == "MVP" || val == "FLEX") {
      state.position = val == "MVP" ? "1" : "2";
      // slot-priced slates send one row per roster slot (captain row at 1.5x
      // salary). The NHL lineup labels the slots CPT/UTIL, so accept either
      // naming; unslotted slates send no slot field and keep the full pool.
      const slots = val == "MVP" ? ["MVP", "CPT"] : ["FLEX", "UTIL"];
      filterPlayers = state.playersDetail.filter((item) =>
        slots.includes(String(item.OperatorRoasterSlots || item.OperatorRosterSlots))
      );
      return filterPlayers.length ? filterPlayers : state.playersDetail;
    } else if (val == "Lck/Exl") {
      filterPlayers = state.playersDetail.filter(
        (_players) =>
          _players.type.includes("lock") || _players.type.includes("exclude")
      );
      return filterPlayers;
    }
    filterPlayers = state.playersDetail.filter((item) => {
      return item.FanDuelPosition == val;
    });
    //console.log(filterPlayers);
    return filterPlayers;
  },

  getFilterByPosition: (state) => (val) => {
    let filterPlayer = [];
    if (val.includes("C")) {
      val = "C";
    } else if (val.includes("W")) {
      val = "W";
    } else if (val.includes("D")) {
      val = "D";
    } else if (val.includes("G")) {
      val = "G";
    } else if (val === "FLEX") {
      filterPlayer = state.playersDetail.filter(
        (player) => !player.DraftKingsPosition.includes("G")
      );
      return filterPlayer;
    } else if (val == "Lck/Exl") {
      // debugger;
      filterPlayer = state.playersDetail.filter(
        (_players) =>
          _players.type.includes("lock") || _players.type.includes("exclude")
      );
      return filterPlayer;
    }

    filterPlayer = state.playersDetail.filter((player) => {
      if (
        state.operator == "DraftKings" &&
        player.DraftKingsPosition !== null
      ) {
        return player.DraftKingsPosition.includes(val);
      } else if (
        state.operator == "FanDuel" &&
        player.FanDuelPosition !== null
      ) {
        return player.FanDuelPosition.includes(val);
      }
    });
    //console.log('filterPlayer', filterPlayer);
    return filterPlayer;
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
